import dataProvider from 'store/dataProvider';
import resources from 'common/constants/resources';
import { requestSaga } from 'common/utils/generators';
import { actionTypes } from '../reducer';

export default function* updateUserStatus() {
  yield requestSaga({
    actionType: actionTypes.updateStatus,
    request: dataProvider.updateMany,
    resource: resources.user.status,
  });
}
